import React, { createContext, useState, useRef, useContext } from "react";

// Create the GlobalDialogContext
const GlobalDialogContext = createContext();

// Create the provider for the dialog
export const GlobalDialogProvider = (
  { children },
  { autoFocusOnClose = false },
) => {
  const [component, setComponent] = useState(null); // This will store the component to be displayed inside the dialog
  const [dialogHeading, setDialogHeading] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dialogRef = useRef(null); // Reference for the dialog element

  // Function to open the dialog (using showModal)
  const openDialog = (component, dialogHeading) => {
    setComponent(component); // Set the dynamic component
    setDialogHeading(dialogHeading);
    setIsOpen(true);
    dialogRef.current.showModal(); // Open the dialog using the showModal method
  };
  // Function to close the dialog (using close)
  const closeDialog = () => {
    setComponent(null); // Reset component when dialog is closed
    setDialogHeading(null);
    setIsOpen(false);
    dialogRef.current.close(); // Close the dialog using the close method
  };

  return (
    <GlobalDialogContext.Provider
      value={{
        openDialog,
        closeDialog,
        component,
        dialogHeading,
        dialogRef,
        isOpen,
        autoFocusOnClose,
      }}
    >
      {children}
    </GlobalDialogContext.Provider>
  );
};

// Custom hook to access the dialog context
export const useGlobalDialog = () => useContext(GlobalDialogContext);
